import { render, staticRenderFns } from "./Detalles.vue?vue&type=template&id=7812e44a"
import script from "./Detalles.vue?vue&type=script&lang=js"
export * from "./Detalles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports